export enum Connectors {
  metaMask = 'metaMask',
  walletConnect = 'walletConnect',
}
